import { DependentModel } from '../models/dependent.model';
import { AppService } from '../app.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Auth from '../helpers/auth';

@Injectable()
export class DependentService extends AppService<DependentModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getAll() {
    const result = await this.getAllAsync(`Responsible/${Auth.getUser().id}/Dependent`);
    return result;
  }

  async getAllFromMeepServer() {
    const result = await this.getAllAsync(`CartoesCashlessNominal/Meus`);
    return result;
  }

  async getByLocal(localId: string): Promise<any> {
    const result = await this.getAllAsync(`CartoesCashlessNominal/Meus?localId=${localId}`);
    return result;
  }

  async getAllFromMeepServerRotativo() {
    const result = await this.getAllAsync(`CartoesCashlessRotativo/Meus`);
    return result;
  }

  async getDashboardFromMeepServer() {
    const result = await this.getAllAsync(`CartoesCashlessNominal/Dashboard`);
    return result;
  }

  async getDashboardFromMeepServerRotativo() {
    const result = await this.getAllAsync(`CartoesCashlessRotativo/Meus`);
    return result;
  }

  async get(id: string) {
    const result = await this.getAsync(`Responsible/${Auth.getUser().id}/Dependent/${id}`);
    return result;
  }

  async getFromMeepServer(id: string, tipo?: string) {
    let result;
    if (tipo) {
      if (tipo === 'rotativo') {
        result = await this.getAsync(`CartaoCashlessRotativo/Meus/${id}`);
      } else {
        result = await this.getAsync(`CartaoCashlessNominal/Meus/${id}`);
      }
    } else {
      result = await this.getAsync(`CartaoCashlessNominal/Meus/${id}`);
    }
    return result;
  }

  async update(dependent: DependentModel) {
    const result = await this.putAsync(`Responsible/${Auth.getUser().id}/Dependent/${dependent.id}`, dependent);
    return result;
  }

  async updateDailyLimit(tag: string, dailyLimit) {
    const result = await this.putAsync(`CartaoCashlessNominal/LimiteDiario`, { Tag: tag, LimiteDiario: dailyLimit });
    return result;
  }

  async updateMinBalance(tag: string, minBalance) {
    const result = await this.putAsync(`CartaoCashlessNominal/SaldoMinimo`, { Tag: tag, SaldoMinimo: minBalance });
    return result;
  }


  async save(dependent: DependentModel) {
    const result = await this.postAsync(`CartaoCashlessNominal`,
      {
        tag: dependent.cardNumber,
        nomeTitular: dependent.name,
        apelido: dependent.nickname,
        localClienteId: dependent.company.id
      } );
    return result;
  }

  async debitFromBalance(pedidoId: string) {
    const result = await this.postAsync(`CartaoCashlessNominal/DebitoRetroativoSaldo`, { pedidoId });
    return result;
  }

  async debitFromCreditCard(CartaoUsuarioMeepId: string, CodigoSeguranca: string, CartaoCashlessId: string, PedidoId: string) {
    const result = await this.postAsync(`Pagamento/DebitoRetroativoCartaoCredito`,
    { CartaoUsuarioMeepId, PedidoId, CodigoSeguranca, CartaoCashlessId });
    return result;
  }

  async getDetails(id: string) {
    const result = await this.getAllAsync(`CartaoCashlessNominal/Pedidos/Detalhes/${id}`);
    return result;
  }

  async buscarPedidosEmAberto() {
    const result = await this.getAllAsync(`CartoesCashlessNominal/BuscarPedidosEmAberto`);
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/dependent.service.ts